// Header.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./HeaderComponent.css";

import logo from "../../assets/images/logo.svg";
// images import
import qu from "../../assets/images/qu.svg";
import ball from "../../assets/images/ball.svg";
import user from "../../assets/users.jpeg"
import { useDispatch, useSelector } from "react-redux";
import {
  CalculationBalance,
  Profile_Image,
  UserDetails,
  userlogout,
} from "../../redux/userSlice";
const HeaderComponent = () => {
  // this is for naviagtion
  const naviagtion = useNavigate();
  const Profile_Image_Url = useSelector(Profile_Image);

  const CalculationResponse = useSelector(CalculationBalance);

  // import dispatchHook in dispatch variable
  const dispatch = useDispatch();

  // logout function and naviagte login page
  const handleLogout = () => {
    // remove item from session storage
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userRole');
    // logout function using redux slice
    dispatch(userlogout());
    // navigate to login page
    naviagtion("/");
  };
  const APi_Url = process.env.REACT_APP_ENIGMA_API;

  const userDetails = useSelector(UserDetails);

  const firstName = userDetails?.firstName;
  const lastName = userDetails?.lastName;
  const ShortName = `${firstName?.charAt(0)}${lastName?.charAt(0)}`.toUpperCase();
  

// console.log("shor name",userDetails?.firstName==""?"no name":"yes name");

// console.log("user role",userDetails.role)
  // format number
  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(number));
  };

  return (
    <header className="header">
      <nav className="header_menu">
        <Link to="#" className="mobilelogo">
          <img src={logo} alt="" />
        </Link>
        {/* <ul className="header_balance">
          <li>
          <div  className="guide_btn fordsk ">
          Aggressive -{" "}
          {CalculationResponse ? (
                  "$"+CalculationResponse.aggressiveDRPT
                ) : (
                   "NA"
                )}
            </div>
          </li>
          <li>
          <div  className="guide_btn fordsk ">
          Neutral -{" "}
          {CalculationResponse ? "$"+CalculationResponse?.neutralDRPT: "NA"}
            </div>
          </li>
          <li>
          <div  className="guide_btn fordsk ">
          Conservative -{" "}
            {CalculationResponse ?  "$"+CalculationResponse?.conservativeDRPT : "NA"}
            </div>
          </li>
        </ul> */}
        <ul>
          {/* <li>
            <Link to="#" className="kevlar_btn fordsk ">
              kevlar
            </Link>
          </li> */}
          {/* <li>
            <Link to="#" className="guide_btn fordsk ">
              reference guide
            </Link>
          </li> */}
          {/* <li>
            <Link to="#">
              <img src={qu} />
            </Link>
          </li> */}
          {/* <li>
            <Link to="#" className="notification">
              <div className="noticeimgbox">
                <img src={ball} />
                <span className="notalart"></span>
              </div>
            </Link>
          </li> */}
          <li className="userlist">
            <div className="usernamebox">{Profile_Image_Url.split("?")[0]!='null'?<img src={APi_Url+Profile_Image_Url}/>:userDetails?.firstName==""?<img src={user} style={{borderRadius:100}}alt="user"/>:ShortName}</div>
            <div className="dropdown">
              <div
                className="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {userDetails?.firstName}
              </div>
              <ul className="dropdown-menu">
                {userDetails?.role=="Dev"?<li>
                  <Link className="dropdown-item" to="/profile" >
                    Profile
                  </Link>
                </li>:null}
                {/* <li>
                  <Link className="dropdown-item" to="/settings">
                    Settings
                  </Link>
                </li> */}
                <li onClick={handleLogout}  style={{cursor:'pointer'}}>
                  <div className="dropdown-item">Logout</div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default HeaderComponent;
